import { useEffect, useState } from "react";
import {
    Navbar,
    NavbarContent,
    NavbarItem,
    NavbarMenuToggle,
    NavbarMenu,
    NavbarMenuItem,
    // Link,
} from "@nextui-org/react";
import BrochurePdf from "../../Assets/pdf/SEA-Brochure.pdf";
import { Link } from "react-router-dom";
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from "@nextui-org/react";
import "../../Assets/css/navigation1.css"
import { ReactComponent as Home } from "../../Assets/svg/home-house-svgrepo-com.svg";
import { ReactComponent as Bulp } from "../../Assets/svg/bulp-svgrepo-com.svg";
import { ReactComponent as Message } from "../../Assets/svg/message-circle-lines-svgrepo-com.svg";
import { ReactComponent as Phone } from "../../Assets/svg/phone-call-phone-svgrepo-com.svg";
import { ReactComponent as Book } from "../../Assets/svg/open-book-book-svgrepo-com.svg";
import { ReactComponent as Career } from "../../Assets/svg/icons-career8.svg";
import logo from "../../Assets/image/logo.png";
import PointerGradientText from "../PointerGradientText";
import { color } from "framer-motion";
import { BASEURL } from "../../constant/constant";

export default function Bar1() {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownOpenF, setDropdownOpenF] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    const toggleDropdownf = () => setDropdownOpenF(!dropdownOpenF);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const menuItems = [
        { label: "Home", path: "/" },
        { label: "Products", path: "/products" },
        { label: "Solution", path: "/solution" },
        { label: "About Us", path: "/about" },
        { label: "Support", path: "/support" },
        {
            label: "Brochure",
            href: BrochurePdf,
            target: "_blank",
            rel: "noreferrer",
            download: true,
        },
        { label: "Tools And Software", path: "/toolsSoftware" },
        {
            label: "Documentation",
            href: "https://docs.seaiot.in/bookse",
            target: "_blank",
        },
        { label: "Career", path: "/career" },
        { label: "Event", path: "/eventsPage" },
        { label: "Case Study", path: "/casestudy" },
        { label: "Customer Stories", path: "/customerstories" },
        { label: "Contact", path: "/contact" },
    ];
    const handleBrochureClick = async (e) => {
        e.preventDefault();

        // 1️⃣ Open tab immediately (user gesture)
        const newTab = window.open("", "_blank");

        try {
            const response = await fetch(
                `${BASEURL}/api/mainbrochure/getmainbrochure`
            );

            const result = await response.json();

            if (result.success && result.data.length > 0) {
                const fileLink = result.data[0].file_link;
                const fullUrl = `${BASEURL}${fileLink}`;

                // 2️⃣ Redirect opened tab to PDF
                newTab.location.href = fullUrl;
            } else {
                newTab.close();
            }
        } catch (error) {
            console.error(error);
            newTab.close();
        }
    };

    return (
        <Navbar className="flex flex-col sm:flex-row items-center justify-between px-4 py-2 bg-[#EAEADF] w-full sm:w-fit h-[50px] rounded-[50px] mt-5">
        {/* // <Navbar className="custom-navbar"> */}
            {/* Mobile Menu Toggle */}
            <NavbarContent className="sm:hidden md:hidden flex items-center justify-center h-full">
                <NavbarMenuToggle
                    style={{ color: 'black' }}
                    aria-label={isMenuOpen ? "Close menu" : "Open menu"}
                    onClick={toggleMenu}
                />
            </NavbarContent>

            <NavbarContent className="sm:hidden md:hidden flex items-center justify-center navlogo h-full p-1">
                <Link to="/" className="cursor-pointer">
                    <img src={logo} alt="Logo" className="responsive-logo" />
                </Link>
            </NavbarContent>

            {/* Center Content for Larger Screens */}
            <NavbarContent className="hidden sm:flex md:flex items-center justify-center gap-4 w-full ">
                <NavbarItem>
                    <Link to="/" class="home-link">
                        <span className="gradient-textHome flex items-center gap-1"><span style={{ fontWeight: 'bold' }}>Home</span></span>
                    </Link>
                </NavbarItem>
                <NavbarItem>
                    <Link color="foreground" to="/products" className="transition gradient-text gap-2">
                        Products
                    </Link>
                </NavbarItem>
                <NavbarItem>
                    <Link color="black" to="/solution" className="solutions-link transition">
                        <PointerGradientText lable="Solution">
                            {/* <Bulp /> */}
                        </PointerGradientText>
                    </Link>
                </NavbarItem>
                <NavbarItem>
                    <Link to="/about" color="foreground" className="transition">
                        <PointerGradientText lable={"About Us"}>
                            {/* <Phone /> */}
                        </PointerGradientText>
                    </Link>
                </NavbarItem>
                <NavbarItem>
                    <Link color="foreground" to="/support" className="gap-2 transition">

                        <PointerGradientText lable={"Support"}>
                            {/* <Phone /> */}
                        </PointerGradientText>
                    </Link>
                </NavbarItem>
                <NavbarItem>
                    <Dropdown isOpen={dropdownOpenF} onOpenChange={toggleDropdownf} portal={true} className="bg-[#EAEADF] z-[1500]">
                        <DropdownTrigger>
                            <Link
                                color="foreground"
                                href="#"
                                className="gap-2 transition"
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                            >
                                <PointerGradientText lable={"Resources"}>
                                    {/* <Message /> */}
                                </PointerGradientText>
                            </Link>
                        </DropdownTrigger>
                        <DropdownMenu aria-label="Static Actions">
                            <DropdownItem key="service-support">
                                <button
                                    onClick={handleBrochureClick}
                                    className="transition inline-block bg-transparent border-none cursor-pointer"
                                >
                                    <PointerGradientText lable="Brochure" />
                                </button>
                            </DropdownItem>
                            <DropdownItem key="case-studies">
                                <Link to="/toolsSoftware" color="foreground" className="transition">
                                    <PointerGradientText lable={"Tools And Software"}>
                                        {/* <Book /> */}
                                    </PointerGradientText>
                                </Link>
                            </DropdownItem>
                            <DropdownItem key="case-studies">
                                <Link to="https://docs.seaiot.in/books" color="foreground" className="transition" target="_blank">
                                    <PointerGradientText lable={"Documentation"}>
                                        {/* <Phone /> */}
                                    </PointerGradientText>
                                </Link>
                            </DropdownItem>
                            {/* <DropdownItem key="case-studies">
                                <Link href="#" color="foreground">
                                    <PointerGradientText lable={"News"}>
                                        <Message />
                                    </PointerGradientText>
                                </Link>
                            </DropdownItem> */}
                        </DropdownMenu>
                    </Dropdown>
                </NavbarItem>
                <NavbarItem>
                    <Link color="foreground" to="/career" className="gap-2 transition">
                        <PointerGradientText lable={"Career"}>
                            {/* <Career /> */}
                        </PointerGradientText>

                    </Link>
                </NavbarItem>
                <NavbarItem>
                    <Link color="foreground" to="/eventsPage" className="gap-2 transition">
                        <PointerGradientText lable={"Event"}>
                            {/* <Career /> */}
                        </PointerGradientText>

                    </Link>
                </NavbarItem>
                <NavbarItem>
                    <Link color="foreground" to="/customerstories" className="gap-2 transition">
                        <PointerGradientText lable={"Customer Stories"}>
                            {/* <Career /> */}
                        </PointerGradientText>

                    </Link>
                </NavbarItem>
                <NavbarItem>
                    <Link to="/contact" color="foreground" className=" transition">
                        <PointerGradientText lable={"Contact"}>
                            {/* <Phone /> */}
                        </PointerGradientText>
                    </Link>
                </NavbarItem>
            </NavbarContent>

            {/* Mobile Menu */}
            <NavbarMenu style={{ marginTop: "25px", maxHeight: "300px" }}>
                {menuItems.map((item, index) => (
                    <NavbarMenuItem key={index}>
                        {item.path ? (
                            <Link className="w-full" to={item.path}>
                                {item.label}
                            </Link>
                        ) : item.href ? (
                            <a
                                className="w-full"
                                href={item.href}
                                target={item.target}
                                rel={item.rel}
                                download={item.download}
                            >
                                {item.label}
                            </a>
                        ) : (
                            <span className="w-full cursor-pointer" onClick={item.onClick}>
                                {item.label}
                            </span>
                        )}
                    </NavbarMenuItem>
                ))}
            </NavbarMenu>
        </Navbar>
    );
}
